import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import { SaleDetailsPageFormData } from "../SaleDetailsPage";

export interface SalesDescriptionProps {
  data: SaleDetailsPageFormData;
  errors: DiscountErrorFragment[];
  clientErrors?: {
    description?: string;
  };
  disabled: boolean;
  onChange: (event: any) => void;
}

const SalesDescription: React.FC<SalesDescriptionProps> = ({
  data,
  disabled,
  errors,
  clientErrors,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["description"], errors);
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Descriptions"
        })}
      />
      <CardContent>
        <TextField
          id="descriptionsTxt"
          disabled={disabled}
          error={!!formErrors.description || !!clientErrors.description}
          helperText={
            getDiscountErrorMessage(formErrors.description, intl) ||
            clientErrors.description
          }
          name={"description" as keyof SaleDetailsPageFormData}
          onChange={onChange}
          label={intl.formatMessage({
            defaultMessage: "Descriptions",
            description: "sales description"
          })}
          value={data.description}
          fullWidth
          multiline
          rows={2}
          rowsMax={4}
        />
      </CardContent>
    </Card>
  );
};
SalesDescription.displayName = "SalesDescription";
export default SalesDescription;
